module.exports = __webpack_public_path__ + "static/media/ProcesarNomina.75597267.svg";